export class ExposureSectorsConstants {
	// TODO wkennerl: clean up sectors after PAS migration is complete
	public static readonly SECTORS: any = {
		basicMaterials: 'cubes',
		communicationServices: 'mobile',
		consumerCyclical: 'car',
		consumerDefensive: 'shopping-cart',
		energy: 'fire',
		financialServices: 'donate',
		healthcare: 'briefcase-medical',
		industrials: 'industry',
		realEstate: 'home',
		technology: 'television',
		utilities: 'lightbulb',
		default: 'puzzle-piece',

		// Fixed Income Bond Sectors
		government: 'landmark',
		governmentRelated: 'landmark',
		municipalTaxable: 'city',  // can be removed once migration is completed
		municipal: 'city',
		usMunicipalTaxAdvantaged: 'city',
		governmentRelatedCombo: 'city',
		corporateBond: 'briefcase',
		convertible: 'briefcase',
		bankLoan: 'briefcase',
		preferred: 'briefcase',
		agencyMortgageBacked: 'shopping-basket',
		assetBacked: 'shopping-basket',
		commercialMortgageBacked: 'shopping-basket',
		coveredBond: 'shopping-basket',
		securitized: 'shopping-basket',
		nonAgencyResidentialMortgageBacked: 'shopping-basket',
		swap: 'chart-line', // can be removed once migration is completed
		derivatives: 'chart-line',
		optionWarrant: 'chart-line',
		futureForward: 'chart-line',
		cashAndEquivalents: 'money-bill-alt'
	};
}
